import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setIsFocusInSearchInput', function (isFocusInSearchInput) {
    getStore().isFocusInSearchInput = isFocusInSearchInput;
});
//# sourceMappingURL=setIsFocusInSearchInput.js.map